import React, { useState } from "react";
import { Button, Form, Input, Card} from "reactstrap";
import logoCiba from "../../assets/images/logo.png";
import { enviarMailRegistro, updatePass, getUsuario } from "../../services/api"
import { useHistory } from "react-router";
import { getUser } from "../../utils";

const initialState = { 
  dni: "", 
  msg: "", 
  socio: null, 
  email: null, 
  celular: null
}

const SolicitarEmail = () => {
    const user = getUser();
    const [state, setState] = useState(initialState);
    const history = useHistory();

  const handleInputChange = async (event) => {
    const target = event.nativeEvent.target;
    const name = target.name;
    const value = target.value;
    await setState({...state,
      [name]: value,
      msg:''
    });

  }

  const handleConfirmMail = async (event) => {
    event.preventDefault();
    try{
        const user_web = await getUsuario(user.numero_documento);
        const response = await updatePass({ 
            dni: user_web.numero_documento, 
            email: state.email, 
            password: user_web.clave_acceso })
    
        if(response.status === 200){
          await enviarMailRegistro({ email: state.email })
          history.push('/InfoSocio')
        }
    }catch(error){
        console.log(error)
    }
  }

  const { msg, email } = state;

  return (
    <>
        <img src={logoCiba} className="logoCiba mt-5" alt=""  />
        <Card className="p-4 text-center mt-4">
          <p className="mt-2 title">
              Por favor indique un correo electrónico para confirmar su cuenta
          </p>
          <Form onSubmit={handleConfirmMail}>
              <p>
                  <Input
                      name="email"
                      placeholder="INGRESAR EMAIL"
                      type="email"
                      className="inputDni"
                      onChange={handleInputChange}
                      required
                  />
              </p>
              <Button className="btn btn-continuar" type="submit" disabled={!email}>
                  Continuar
              </Button>
              <p >{msg}</p>
          </Form>
        </Card>
    </>
  );
}

export default SolicitarEmail;
